<template>
    <Dialog :visible="visible" @update:visible="$emit('update:visible', $event)" modal :header="header" style="width: 40rem">
        <DataTable :value="registrations" :loading="loading" dataKey="id" stripedRows sortMode="single" :defaultSortOrder="-1" sortField="date">
            <Column field="date" header="Dato" sortable>
                <template #body="{ data }">
                    {{ formatDate(data.date) }}
                </template>
            </Column>
            <Column field="item_name" header="Type" sortable>
                <template #body="{ data }">
                    <span class="user-registrations-dialog__item-option">
                        <img
                            v-if="data.illustration_src"
                            :src="data.illustration_src"
                            :alt="data.illustration_alt || data.item_name"
                            class="user-registrations-dialog__item-icon"
                        >
                        {{ data.item_name }}
                    </span>
                </template>
            </Column>
            <Column field="amount" header="Mengde" sortable>
                <template #body="{ data }">
                    {{ data.amount }} {{ data.uom }}
                </template>
            </Column>
            <Column field="location_name" header="Sted" sortable />

            <template #empty>
                Ingen registreringer funnet.
            </template>
        </DataTable>
    </Dialog>
</template>
<script>
import Dialog from 'primevue/dialog';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

export default {
    components: {
        Dialog,
        DataTable,
        Column,
    },
    props: {
        visible: { type: Boolean, required: true },
        user: { type: Object, default: null },
        itemId: { type: Number, default: null },
        itemName: { type: String, default: null },
        year: { type: Number, default: null },
    },
    emits: ['update:visible'],
    data() {
        return {
            registrations: [],
            loading: false,
        };
    },
    computed: {
        header() {
            if (!this.user) {
                return 'Registreringer';
            }

            const suffix = [this.itemName, this.year].filter(Boolean).join(' ');

            return suffix ? `Registreringer: ${this.user.name} – ${suffix}` : `Registreringer: ${this.user.name}`;
        },
    },
    watch: {
        visible(isVisible) {
            if (!isVisible || !this.user) {
                return;
            }

            this.fetchRegistrations();
        },
    },
    methods: {
        async fetchRegistrations() {
            this.loading = true;
            this.registrations = [];

            try {
                const params = new URLSearchParams();
                if (this.itemId) {
                    params.set('item', this.itemId);
                }
                if (this.year) {
                    params.set('year', this.year);
                }

                const query = params.toString();
                const response = await fetch(`/api/v1/user/${this.user.id}/registrations${query ? `?${query}` : ''}`);
                this.registrations = await response.json();
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },
        formatDate(date) {
            return new Date(date).toLocaleDateString('no-NO', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            });
        },
    },
};
</script>
<style scoped>
.user-registrations-dialog__item-option {
    display: flex;
    align-items: center;
    gap: 8px;
}

.user-registrations-dialog__item-icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
}
</style>
